import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Link } from "react-router-dom";
import { CreditCard, BadgeEuro, Truck, PackageCheck, Check, ShieldCheck, ArrowRight } from "lucide-react";

const STEPS = [
  [CreditCard, "The buyer pays at purchase", "The buyer is charged the full amount when they buy. The payment is captured and held safely by ARTFUTUR — it does not reach the artist yet."],
  [BadgeEuro, "We hold the funds", "The money sits securely in ARTFUTUR's account while the artist is notified and prepares the artwork for shipment."],
  [Truck, "The artist ships with tracking", "The artist ships the work and adds a tracking number. The buyer follows the delivery in their dashboard — the sooner it ships, the sooner the artist is paid."],
  [PackageCheck, "The buyer confirms delivery", "Once the artwork arrives and is inspected, the buyer confirms delivery in one click."],
  [Check, "The artist is paid", "ARTFUTUR releases the payout to the artist and keeps a flat 20% commission. Fast delivery means fast payment."],
];

export default function HowItWorks() {
  return (
    <div>
      <Navbar />
      <div className="bg-[var(--bg-dark)] text-white relative grain">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-20 text-center">
          <div className="escrow-badge mx-auto"><ShieldCheck className="w-3.5 h-3.5" /> Paid on delivery</div>
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl mt-6 leading-tight">How ARTFUTUR works</h1>
          <p className="text-stone-400 mt-5 max-w-2xl mx-auto">
            Buying and selling art across the world should be simple and safe. The buyer pays at purchase,
            we hold the funds, and the artist is paid the moment the work is delivered.
          </p>
        </div>
      </div>

      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="relative">
          <div className="absolute left-6 top-4 bottom-4 w-0.5 bg-[var(--border-subtle)]" />
          <div className="space-y-10">
            {STEPS.map(([Icon, t, d], i) => (
              <div key={t} className="flex gap-6 relative">
                <div className="w-12 h-12 rounded-full bg-[var(--gold)] text-white flex items-center justify-center shrink-0 z-10">
                  <Icon className="w-5 h-5" />
                </div>
                <div className="pt-1">
                  <div className="overline-badge">Step {i + 1}</div>
                  <h3 className="font-serif text-2xl mt-1">{t}</h3>
                  <p className="text-[var(--text-secondary)] mt-2 leading-relaxed">{d}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-16 p-8 rounded-2xl bg-[var(--bg-secondary)] text-center">
          <h3 className="font-serif text-2xl">Ready to collect with confidence?</h3>
          <Link to="/gallery" className="btn-gold inline-flex items-center gap-2 px-7 py-3.5 rounded-full text-sm font-semibold mt-5">
            Browse the gallery <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
      <Footer />
    </div>
  );
}
